import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom, shape }: Theme) => ({
  formControl: {
    width: '100%',
  },
  select: {
    marginTop: 8,
    marginBottom: 4,
  },
  checkbox: {
    padding: 5,
  },
  selectMenu: {
    padding: 5,
  },
  root: {
    '&&': {
      paddingRight: 46, // https://github.com/mui-org/material-ui/issues/24453
    },
  },
  menuItem: {
    padding: '0 10px 0 5px',
    borderRadius: shape.borderRadius,
    border: '2px solid transparent',
    '&[aria-selected="true"]': {
      backgroundColor: custom.status.warning.main,
      border: '2px solid #f06000',
    },
    '&:hover': {
      backgroundColor: custom.status.warning.main,
      border: '2px solid #f06000',
    },
    '&:focus-visible': {
      backgroundColor: custom.status.warning.main,
      border: '2px solid #f06000',
    },
  },
  icon: {
    color: custom.grey[4],
    transition: 'all 300ms ease',
    right: 14,
  },
}));
